import { useState } from "react";
import { resolvePlateCandidates } from "../lib/api";

export default function usePlateSearch() {
  const [plate, setPlate] = useState("");          // applied filter: "ABC123" or "=ALIAS"
  const [plateText, setPlateText] = useState("");  // input value
  const [plateMatches, setPlateMatches] = useState([]); // suggestion list (strings or objects)

  const clear = () => {
    setPlate("");
    setPlateText("");
    setPlateMatches([]);
  };

  const applyCandidate = (c) => {
    // Allow string or { plate, is_alias }
    const p = typeof c === "string" ? c : (c?.plate || "");
    const isAlias = typeof c === "object" && !!c.is_alias;
    if (!p) return;
    setPlate(isAlias ? `=${p}` : p);
    setPlateText(p);
    setPlateMatches([]);
  };

  const runSearch = async () => {
    const q = (plateText || "").trim();
    if (!q) return clear();

    // If user explicitly typed exact (leading "="), apply immediately.
    if (q.startsWith("=")) {
      const exact = q.slice(1).trim();
      if (exact) {
        setPlate(`=${exact}`);
        setPlateText(exact);
      } else {
        setPlate("");
      }
      setPlateMatches([]);
      return;
    }

    try {
      const candidates = await resolvePlateCandidates(q);
      if (!Array.isArray(candidates) || candidates.length === 0) {
        setPlateMatches([]);
        return;
      }
      if (candidates.length === 1) {
        applyCandidate(candidates[0]);
        return;
      }
      setPlateMatches(candidates);
    } catch {
      setPlateMatches([]);
    }
  };

  return {
    plate,
    plateText,
    setPlateText,
    plateMatches,
    runSearch,
    clear,
    applyCandidate,
  };
}
